import { useState } from 'react';
import { MeasurementDateName } from 'api';
import { COMPANY_TYPE } from 'common/constants/pageTypes';
import { initialFormValues } from 'layouts/Main/components/ExcelExportDialog/constants';
import { ExcelExportDialogErrors } from 'layouts/Main/components/ExcelExportDialog/types';
import { useGenerateReports } from 'layouts/Main/components/ExcelExportDialog/utils';
import { StyledFab, StyledParagraph } from './DownloadWaterfall.styles';

const DownloadWaterfall = ({
  exitDate,
  equityValue,
  companyMeasurementDate,
  selectedCapTableId,
  selectedCompanyId,
}: {
  exitDate: string;
  equityValue: number;
  selectedCapTableId: number;
  companyMeasurementDate: MeasurementDateName;
  selectedCompanyId: number;
}) => {
  const [reportError, setReportError] = useState<string | undefined>();
  const errorHandler = (errors: ExcelExportDialogErrors) => {
    const errorMessages = Object.values(errors).flat();
    if (errorMessages.length > 0) {
      setReportError(errorMessages.join(' '));
    } else {
      setReportError(undefined);
    }
  };
  const companyInfo = { id: selectedCompanyId };
  // we fix the page type to COMPANY_TYPE because we only need company level data for waterfall reports
  // (if we set it to FIRM_TYPE the report generation logic will expect firm data)
  const { generateWaterfallReport, isLoading } = useGenerateReports({
    pageType: COMPANY_TYPE,
    companyInfo,
    fundInfo: null,
    firmInfo: null,
    formValues: {
      ...initialFormValues,
      export_waterfall: true,
      waterfall_cap_table: selectedCapTableId,
    },
    waterfallParameters: {
      exit_date: exitDate,
      exit_equity_value: equityValue,
    },
    currentMeasurementDate: companyMeasurementDate,
    setErrors: errorHandler,
  });
  const onClick = () => {
    generateWaterfallReport();
  };
  return (
    <>
      {reportError ? <StyledParagraph>{reportError}</StyledParagraph> : null}
      <StyledFab variant="extended" color="primary" onClick={onClick} size="medium" disabled={isLoading}>
        Download Waterfall
      </StyledFab>
    </>
  );
};

export default DownloadWaterfall;
